import CustomLink from 'components/shared/CustomLink';

type TFunction = (key: string) => string;

export const getPowerplugsPageFaqData = (t: TFunction) => [
  {
    title: t('powerplugsPage.faq.q1.title'),
    description: (
      <div>
        {t('powerplugsPage.faq.q1.p1')}
        <br />
        {t('powerplugsPage.faq.q1.p2')}
      </div>
    ),
  },
  {
    title: t('powerplugsPage.faq.q2.title'),
    description: <div>{t('powerplugsPage.faq.q2.body')}</div>,
  },
  {
    title: t('powerplugsPage.faq.q3.title'),
    description: (
      <div>
        {t('powerplugsPage.faq.q3.p1')}
        <br />
        {t('powerplugsPage.faq.q3.p2')}
      </div>
    ),
  },
  {
    title: t('powerplugsPage.faq.q4.title'),
    description: (
      <div>
        <b>{t('powerplugsPage.faq.q4.freeHeader')}</b>
        <ul>
          <li>{t('powerplugsPage.catalogue.plugs.vitaminD.title')}</li>
          <li>{t('powerplugsPage.catalogue.plugs.caffeineWindow.title')}</li>
          <li>{t('powerplugsPage.faq.q4.circadianAlignment')}</li>
          <li>{t('powerplugsPage.faq.q4.cycleTracking')}</li>
          <li>{t('powerplugsPage.catalogue.plugs.pregnancyInsights.title')}</li>
        </ul>
        <br />
        <b>{t('powerplugsPage.faq.q4.premiumHeader')}</b>
        <ul>
          <li>{t('powerplugsPage.catalogue.plugs.afib.title')}</li>
          <li>
            {t('powerplugsPage.catalogue.plugs.cardioAdaptability.title')}
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: t('powerplugsPage.faq.q5.title'),
    description: (
      <div>
        {t('powerplugsPage.faq.q5.before')}{' '}
        <CustomLink
          href="https://ultrahumanapp.notion.site/AFib-Detection-Troubleshooting-a26fc737142e4cadab456d7032846405#143755317a918057a3e8ec10fe675876"
          target="_blank"
          onClick={(e) => e.stopPropagation()}
          style={{ textDecoration: 'underline', color: 'black' }}
        >
          {t('powerplugsPage.faq.q5.moreLink')}
        </CustomLink>
        {t('powerplugsPage.faq.q5.after')}
      </div>
    ),
  },
  {
    title: t('powerplugsPage.faq.q6.title'),
    description: <div>{t('powerplugsPage.faq.q6.body')}</div>,
  },
];
